/**
 * Bangladeshi taka.
 */
export var BDT = {
  code: 'BDT',
  base: 10,
  exponent: 2
};